import { ApplicationLocalizationResourceDto } from '@unistocks/proxy/axios-client';
import { MergedResources, ResourceDto } from '@unistocks/shared/localization/types/resource';
import { Dict } from 'i18n-js';
// Copied from ABP Angular project

export function recursivelyMergeBaseResources(
  baseResourceName: string,
  source: ResourceDto
): ApplicationLocalizationResourceDto {
  const item = source[baseResourceName];

  if (item.baseResources.length === 0) {
    return item;
  }

  return item.baseResources.reduce((acc, baseResource) => {
    const baseItem = recursivelyMergeBaseResources(baseResource, source);
    const texts = { ...baseItem.texts, ...item.texts };
    return { ...acc, texts };
  }, item);
}

export function mergeResourcesWithBaseResource(resource: ResourceDto): MergedResources {
  const entities: Array<[string, ApplicationLocalizationResourceDto]> = Object.keys(resource).map(
    key => {
      const newValue = recursivelyMergeBaseResources(key, resource);
      return [key, newValue];
    }
  );

  return entities.reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value.texts }),
    {} as MergedResources
  );
}

export function mapResourcesToI18nDict(resources: Record<string, Record<string, string>>): Dict {
  return Object.entries(resources).reduce(
    (res, [resourceName, resource]) => {
      const mappedResource: Dict = {};

      Object.keys(resource).forEach(key => {
        if (/'{|{/g.test(resource[key])) {
          mappedResource[key] = resource[key].replace(/'{|{/g, '{{').replace(/}'|}/g, '}}');
        } else {
          mappedResource[key] = resource[key];
        }
      });

      res[resourceName] = mappedResource;

      return res;
    },
    {} as Record<string, Dict>
  );
}
